import { otp } from 'src/config/yup';
import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import CustomTextField from '../formFields/textField';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import LoaderButton from '../loaderButton/loaderButton';
// import { verifyOTPAction } from 'src/redux/features/auth/action;
import { constants, OTP_VERIFICATION_MODE, showErrorTost, showSuccessTost } from 'src/constants';
import { t } from 'i18next';
import { VERIFY_OTP_LOGIN } from 'src/apiService/apiDeclaration';
import { getLoggedInUser } from 'src/redux/features/auth/actions';
import { setToken } from 'src/redux/features/auth/slice';
import { storeData } from 'src/helper/storageHelper';

const OTPForm = ({ email, verificationMode }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(otp),
  });

  const verifyOTP = async (data) => {
    setLoading(true);
    const body = {
      email: email,
      verificationMode: verificationMode,
      otp: data.otp,
    };
    try {
      const resp = await VERIFY_OTP_LOGIN(body);
      let token = resp?.data?.token;

      showSuccessTost(resp?.message);

      if (token) {
        if (verificationMode !== OTP_VERIFICATION_MODE.ACCOUNT_RECOVERY) {
          dispatch(setToken(token));
        }
        storeData(constants.authToken, token);
      }

      if (verificationMode === OTP_VERIFICATION_MODE.ACCOUNT_RECOVERY) {
        navigate('/user/reset-password');
      }

      if (verificationMode === OTP_VERIFICATION_MODE.LOGIN && token) {
        dispatch(getLoggedInUser());
      }

      if (
        verificationMode === OTP_VERIFICATION_MODE.JOIN_USER ||
        verificationMode === OTP_VERIFICATION_MODE.NEW_USER
        // verificationMode === OTP_VERIFICATION_MODE.ACCOUNT_RECOVERY
      ) {
        navigate('/');
      }
    } catch (error) {
      showErrorTost(error.message);
      console.error('Error verifying OTP:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ width: '100%', margin: '0 auto' }}>
      <form onSubmit={handleSubmit(verifyOTP)}>
        <Grid item xs={12}>
          <CustomTextField
            label={t('verifyotp.label')}
            type="text"
            controller={{
              name: 'otp',
              control: control,
              errors: errors.otp,
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2, float: 'right' }}>
          <LoaderButton
            type="submit"
            loading={loading}
            variant="contained"
            disabled={!isValid}
            buttonText={t('verifyotp.heading')}
          />
        </Grid>
      </form>
    </Box>
  );
};

export default OTPForm;
